import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalFooter from '../components/common/LegalFooter';

const AccessibilityPage = () => {
  const { t } = useTranslation();

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-box">
          <div className="login-logo">
            <h1>{t('accessibility.title')}</h1>
            <p>{t('accessibility.subtitle')}</p>
          </div>

          <div className="card" style={{ padding: 24 }}>
            <p>{t('accessibility.commitment')}</p>
            <h2 style={{ marginTop: 20 }}>{t('accessibility.measuresTitle')}</h2>
            <ul style={{ paddingLeft: 20, marginTop: 12 }}>
              <li>{t('accessibility.measure1')}</li>
              <li>{t('accessibility.measure2')}</li>
              <li>{t('accessibility.measure3')}</li>
            </ul>

            <h2 style={{ marginTop: 20 }}>{t('accessibility.feedbackTitle')}</h2>
            <p>{t('accessibility.feedbackText')}</p>
            <p>
              <a href="mailto:confidentialite@centredejourensante.ca">
                confidentialite@centredejourensante.ca
              </a>
            </p>
          </div>
          <LegalFooter />
        </div>
      </div>
    </div>
  );
};

export default AccessibilityPage;
